var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.098 46.0715C120.378 55.3085 121.824 65.6075 120.252 75.6662C118.68 85.7248 114.16 95.0913 107.264 102.581C100.369 110.071 91.4069 115.348 81.5122 117.745C71.6175 120.142 61.2344 119.55 51.6757 116.046C42.117 112.542 33.8122 106.282 27.8113 98.0575C21.8104 89.8332 18.3831 80.0142 17.9626 69.8421C17.5422 59.67 20.1476 49.6016 25.4493 40.9102C30.751 32.2188 38.5109 25.2947 47.7478 21.0135C53.8809 18.1699 60.5141 16.5624 67.2685 16.2828C74.0229 16.0032 80.7663 17.0569 87.1134 19.3839C93.4605 21.7108 99.2871 25.2654 104.26 29.8445C109.233 34.4236 113.256 39.9376 116.098 46.0715Z",
    fill: "#0092FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6676 85.9884C75.4193 85.4498 80.8819 83.217 85.3642 79.5726C89.8465 75.9283 93.147 71.0362 94.8479 65.5154C96.5489 59.9947 96.5739 54.0934 94.9198 48.5584C93.2657 43.0234 90.0068 38.1035 85.5556 34.4213C81.1044 30.7391 75.6609 28.4601 69.9139 27.8727C64.167 27.2853 58.375 28.416 53.2709 31.1215C48.1668 33.8271 43.98 37.9859 41.2403 43.0718C38.5006 48.1577 37.3313 53.942 37.8802 59.6927C38.2398 63.5069 39.3474 67.2129 41.1397 70.5988C42.932 73.9848 45.3739 76.9845 48.3258 79.4265C51.2778 81.8684 54.682 83.7048 58.3439 84.8307C62.0058 85.9567 65.8536 86.35 69.6676 85.9884Z",
    fill: "#F4F4F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0396 114.421C92.9662 113.524 94.8364 112.51 96.6396 111.385C93.5679 108.124 89.7963 105.602 85.609 104.01C81.4216 102.418 76.9276 101.797 72.4654 102.194C68.0032 102.59 63.6891 103.994 59.8481 106.3C56.0071 108.605 52.7393 111.752 50.2908 115.503C56.7967 118.116 63.7688 119.368 70.7772 119.182C77.7856 118.996 84.6815 117.375 91.0396 114.421Z",
    fill: "#F4F4F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.098 46.0715C116.017 45.9024 115.929 45.7401 115.854 45.571C111.159 51.0039 108.781 58.0603 109.228 65.2268C109.676 72.3932 112.914 79.0988 118.248 83.9053C122.389 71.4821 121.62 57.9454 116.098 46.0715Z",
    fill: "#F4F4F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6899 89.3633C23.1498 90.3575 23.6435 91.3179 24.1575 92.258C26.1601 88.1349 27.0906 83.5733 26.8628 78.9952C26.4819 72.0292 23.4727 65.4669 18.4425 60.6329C17.0612 70.4189 18.5361 80.3956 22.6899 89.3633Z",
    fill: "#F4F4F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3902 65.3807C69.9632 65.3015 70.5085 65.0849 70.9796 64.7492C71.4507 64.4135 71.8336 63.9689 72.0955 63.4531C72.6058 62.176 72.6608 60.7621 72.2511 59.4493C72.0192 58.2165 71.3839 57.0959 70.4453 56.2638C69.9818 55.9122 69.444 55.6715 68.873 55.5601C68.3021 55.4487 67.7132 55.4696 67.1516 55.6213C66.5637 55.7196 66.0013 55.9341 65.4973 56.2523C64.9933 56.5705 64.5578 56.9859 64.2163 57.4744C63.8805 57.9093 63.6456 58.4135 63.5286 58.9504C63.4117 59.4873 63.4155 60.0435 63.54 60.5788C63.8497 62.0482 64.6282 63.3773 65.7583 64.3662C66.2325 64.8054 66.8038 65.1263 67.4255 65.3026C68.0473 65.4789 68.702 65.5056 69.3361 65.3807H69.3902ZM56.8917 59.5575C55.5074 53.7636 55.7058 49.2097 57.4868 45.8957C59.2678 42.5816 62.6089 40.4444 67.51 39.4841C68.8285 39.1982 70.1718 39.0419 71.5207 39.0174L72.6907 43.9614C71.4729 43.9198 70.2544 44.0173 69.0588 44.2522C67.2686 44.5263 65.5641 45.2039 64.0743 46.2338C62.921 47.073 62.0921 48.284 61.7274 49.6628C61.3646 51.5108 61.3969 53.4146 61.8221 55.2493L62.0859 55.2019C62.8704 52.668 64.7213 51.1169 67.6385 50.5488C68.7905 50.2654 69.9896 50.2309 71.1559 50.4479C72.3222 50.6648 73.4288 51.1281 74.4018 51.8068C76.282 53.1594 77.5738 55.2831 78.2637 58.1845C79.0166 61.3092 78.7258 63.9581 77.3912 66.1314C76.0385 68.2957 73.8269 69.6957 70.6888 70.3043C68.6803 70.7354 66.5916 70.5996 64.6559 69.9121C62.7416 69.1774 61.0793 67.9072 59.8675 66.2531C58.4161 64.2518 57.4001 61.9686 56.8849 59.5507L56.8917 59.5575Z",
    fill: "#007ECC"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M99.1016 108.213C77.2156 124.444 49.9528 124.701 38.232 108.842C26.5112 92.9816 34.688 66.9565 56.574 50.7246C78.46 34.4927 105.73 34.2357 117.444 50.0957C129.158 65.9556 120.994 91.9807 99.1016 108.213Z",
    fill: "url(#paint0_radial_91_890)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.459,
    width: 82.5121,
    height: 85.2174,
    fill: "url(#pattern0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.6714,
    y: 79.8068,
    width: 77.1014,
    height: 60.1932,
    fill: "url(#pattern1)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6.08696,
    width: 66.9565,
    height: 73.7198,
    fill: "url(#pattern2)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M32.6455 36.4135C32.2735 39.4773 39.6861 38.5304 49.202 34.2966C58.718 30.0628 66.7324 24.1517 67.0977 21.0879C67.4629 18.0241 60.0571 18.971 50.5411 23.2048C41.0252 27.4386 33.0175 33.3497 32.6455 36.4135Z",
    fill: "url(#paint1_radial_91_890)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M66.8541 56.3594C73.1816 41.2478 67.6388 24.5288 54.4738 19.0163C41.3089 13.5039 25.5072 21.2856 19.1796 36.3972C12.8521 51.5088 18.3949 68.2278 31.5599 73.7403C44.7248 79.2527 60.5266 71.471 66.8541 56.3594Z",
    fill: "url(#paint2_radial_91_890)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M66.2049 30.7594C62.2822 31.4357 59.5228 34.7497 60.0436 38.199C60.5644 41.6483 64.1624 43.8734 68.0851 43.2038C72.0078 42.5343 74.774 39.2135 74.2532 35.7642C73.7325 32.315 70.1276 30.0898 66.2049 30.7594Z",
    fill: "url(#paint3_radial_91_890)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_91_890",
    transform: "scale(0.00819672 0.00793651)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_91_890",
    transform: "scale(0.00877193 0.011236)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_91_890",
    transform: "scale(0.010101 0.00917431)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_91_890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.389 81.3089) rotate(53.4475) scale(35.6032 49.3104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9BA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#9B9BA3",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#9B9BA3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_91_890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.5312 26.2321) rotate(156.067) scale(18.8083 4.75749)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "white",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_91_890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.2313 45.2758) rotate(-152.85) scale(25.8733 29.6627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_91_890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.52 31.2811) rotate(-98.4711) scale(6.29585 7.20853)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_91_890",
    width: 122,
    height: 126,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_91_890",
    width: 114,
    height: 89,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHIAAABZCAYAAADitnCIAAAACXBIWXMAAAsSAAALEgHS3X78AAAEAklEQVR4Xu2c208TURCHv61UNDRKvOM1UTRK4pvxRf9+HzTRBxPjPfGKeIsQUKFofZid9Ox2C0TQnp38vqQ5wPbGfnvmzMxpWgwGA0T76Wx3B9EOJDIIEhkEiQyCRAZBIoMgkUGQyCBIZBAkMggSGQSJDIJEBkEigyCRQZDIIEhkECQyCBIZBIkMgkQGQSKDIJFBkMggSGQQJDIIEhkEiQyCRAZBIoMgkUGQyCBMbXeHzClqozOojeFpg8hxsgqgC+wvRz8+APrARjmOkxlKds4iCyz0TwHTVGVR/n4IOFGO/r9sAivAx3LsM0qT7FaLzVGkC+wCM8AR4BRDWS5zGjgJXCrH6fLv68AS8KIc16kyoCp7GZPZJLY1UnMT6QJ7wFHgPHAZuEpVVoG993RGdstjfaozcpNRIXXZa5jQj8A34Gd52wR+Nzw+O4qMvtWjAxzExFwErgDXMZHnqMqC3a2RqexlTOQS8Bx4D3wCFoGv5bE+mQvNRWSBCTkN3ABuAQvABWxmzjC6Rvrj0tHZbr2ry+5jQpeAz8Bb4DHwDHgNfCFzoTmF1mngDHATuI1J7GECO4zK2opxglM62Gv6WjiLrcU/sfC6gIl8SFXoKkOh2ZCLSA+Th4GzwFz5c5rc7DV12R0sKvSw1z7GcI12oU+Bl1hI/kFGMnMRCcMExkuNffw7iU0UVKV61uxJ1zzwCLgD3MPW0g0yCbM5ifSyYJ1htjipFmKBXUj1MuhoefwLlix9A341PcH/JheRnnwsA++w0NXDTuCkZEJVqJ+rBeAJtmaukknyM8mTVGcdk3gfeIBljmvYFT/pE+VCe1iYvYolRl7XTpzcZuQnTGTabpvj77PXvaSpCeHJ2KQvtGxEgoWoH9hMhGEb7RrN9WSanPwPBrVbVuQkEiyMuswNrEB/TLXDMwscoNpI30nd+LcMsIusj62Ji9gSsExz+28i5CYSTOZ3hifrDVbHec/1LFbjncTqvS7NrTpnp5KbukEe8tewTPUVVoLcxd5fvSE/MXJp0TVRMJr+zwHHsVbePCZzBhNab577c2wl2RnXn/WerF9M2TYFchbpuNApLKQewMLrCUzgDM3bWU3JSSo5ZdyOie+S1Puu2bXp2iDSSROcdJZ5a6+eScL4Pcs6TXuY3qBYAT6Q+U5Im0SmpOveVuGzS3O5kJIKq3+qwENu2m3K8oS1VWSdcQnNbtdIP5aOWRJF5FbsJmttDTmWH3tNqwXtlJx6rWIXSGQQJDIIEhkEiQyCRAZBIoMgkUGQyCBIZBAkMggSGQSJDIJEBkEigyCRQZDIIEhkECQyCBIZBIkMgkQGQSKDIJFBkMggSGQQJDIIEhkEiQyCRAZBIoMgkUH4A/cKIO8+9htIAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_91_890",
    width: 99,
    height: 109,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.2efe1303c4916020197a05833859083f.svg";
export { ForwardRef as ReactComponent };